import { Tag } from 'antd'
import React from 'react'
import { s } from './style'

const Facilities: React.FC<{ featureNames: string[] }> = ({ featureNames }) => {
  return (
    <>
      {featureNames?.map((featureName) => {
        return (
          <Tag style={s.tag} key={featureName}>
            {featureName}
          </Tag>
        )
      })}
    </>
  )
}

export default Facilities
